import { List, Sheet, Assets, LedgerDetails } from "../Components/index.js";

export default [
    { path: "/audit/store/stock", component: List, name: "audit.store.stock" },
    { path: "/audit/store/assets", component: Assets, name: "audit.store.assets" },
    { path: "/audit/store/sheet", component: Sheet, name: "audit.store.sheet" },
    { path: "/store/audit-ledger/update", component: LedgerDetails, name: "store.audit.ledger.update" }
];
